export default class CredentialError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message =
      message ||
      'Credenciais inválidas! ';
    this.errorCode = errorCode || 401;
  }
}